import React, { useState, useEffect, useContext } from 'react';
import { eventControlAction, getEvent } from '../services/eventService';
import { EventContext } from '../context/EventContext';
import { useToast } from '../context/ToastContext';

const EventControlsPage: React.FC = () => {
    const { currentEvent, setCurrentEvent } = useContext(EventContext); // Event data in context
    const { addToast } = useToast();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        fetchEvent();
    }, []);

    const fetchEvent = async () => {
        try {
            if (currentEvent) {
                const response = await getEvent(currentEvent.event_id);
                setCurrentEvent(response);
            }
        } catch (error) {
            console.error("Error fetching event data", error);
            addToast("Failed to fetch event data.", true);
        }
    };

    const handleAction = async (actionEndpoint: string, successMessage: string) => {
        setLoading(true);

        if (currentEvent && !currentEvent.is_locked) {
            try {
                await eventControlAction(currentEvent.event_id, actionEndpoint);
                addToast(successMessage);
                fetchEvent(); // Refresh event data after action
            } catch (error) {
                console.error("Error performing action", error);
                addToast("Failed to perform action.", true);
            } finally {
                setLoading(false);
            }
        } else {
            addToast('Missing event or event is locked.', true);
        }
    };

    return (
        <div className="card" style={{maxWidth: '900px'}}>
            <h2>{currentEvent ? `Event Controls for ${currentEvent.event_name}` : 'No event selected'}</h2>

            {/* Table of Event Controls */}
            {currentEvent && (
                <table>
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Action : Toggle</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[
                            { label: 'Event', state: currentEvent.event_open, endpoint: 'open', closeEndpoint: 'close' },
                            { label: 'Registration', state: currentEvent.registration_open, endpoint: 'open-registration', closeEndpoint: 'close-registration' },
                            ...(currentEvent.has_checkin ? [{ label: 'Check-in', state: currentEvent.checkin_open, endpoint: 'open-checkin', closeEndpoint: 'close-checkin' }] : []),
                            // { label: 'Confirmation', state: currentEvent.confirmation_open, endpoint: 'open-confirmation', closeEndpoint: 'close-confirmation' },
                        ].map(({ label, state, endpoint, closeEndpoint }) => (
                            <tr key={label}>
                                <td style={{ color: state ? 'black' : 'gray' }}>
                                    {label} {state ? 'Open' : 'Closed'}
                                </td>
                                <td>
                                    <button className="actionButton"
                                        onClick={() => handleAction(state ? closeEndpoint : endpoint, state ? `${label} Closed` : `${label} Opened`)}
                                        disabled={loading || currentEvent.is_locked}
                                        style={{
                                            backgroundColor: state ? '#333' : '#888', // Darker when enabled, grayed when disabled
                                        }}
                                    >
                                        {state ? `Close ${label}` : `Open ${label}`}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

        </div>
    );
};


export default EventControlsPage;
